module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "ppp-differentpaths007htmlacknow"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/OEBPS/pppdifferentpaths006#ppp-differentpaths006htmltoc"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("As always, I couldn’t have written this book without the help of many people. Well, I could’ve written it, I guess, but it wouldn’t have been nearly as good.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Paula Meabon has been with me all the way with this series, and her first-person accounts of farming events and mishaps have enlivened the books from day one. She also takes the time to proofread the manuscripts, to make sure I’m not making too many glaring errors about dairy farming, and I appreciate it immensely.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Detective Randall Floyd of the Telford Police has been another faithful resource. Without him Detective Willard wouldn’t have been half as smart, and Stella would’ve gotten herself into much more trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Lorin Beidler, MD, first gave me the idea for Nick’s illness, and Tami Forbes helped to make it realistic. Dr. Beidler also helped with other medical details in this book, which I won’t name here or it would give things away.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Pastor Philip Clemens discussed Scripture and religious issues with me, pointing me toward relevant Biblical passages and current events.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Ron Baldridge, DVM, helped make sure Carla’s veterinary supplies and activities were correct.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Identification Officer David Hammond of the Lima Police Department made sure I knew what I was talking about when it came to fingerprints.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Lee Jay Diller shared his knowledge of large trucks and their tires.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The Poisoned Pen Press crew—made up of Rob, Jessica, Marilyn, and Nan—is wonderful, and I thank them for all they do to make writing and publishing a book a joyful experience. Having Barbara Peters as my editor is an honor and a privilege, and not something I will ever take for granted.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Phil and Nancy Clemens, besides being great parents, are my trusted first readers, and I thank them for reading quickly and critically.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Steve, Tristan, and Sophia allow me the privilege of having a job I love. I could not do it without their support.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("And thanks to Mike Grieser for the joke. There aren’t very many jokes Stella would find funny. This was one of them.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a3875df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-differentpaths007.vue
// module id = 72
// module chunks = 0